import { render, staticRenderFns } from "./oldPhone.vue?vue&type=template&id=a248e1bc"
import script from "./oldPhone.vue?vue&type=script&lang=js"
export * from "./oldPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports